// extracted by mini-css-extract-plugin
export default {"p3":"P3_p3__7xjKV","bold":"P3_bold__8ixdL"};